// helpers/LogHelper.js
import { LambdaURLs } from "../Enums";

export function createLogger({
  enabled = true,
} = {}) {
  const base = (level, prefix, args) => {
    if (!enabled) return;

    switch (level) {
      case "error":
        console.error(prefix, ...args);
        break;
      case "warn":
        console.warn(prefix, ...args);
        break;
      default:
        console.log(prefix, ...args);
        break;
    }
  };

  return {
    log(prefix, ...args) {
      base("log", prefix, args);
    },
    info(prefix, ...args) {
      base("log", prefix, args);
    },
    warn(prefix, ...args) {
      base("warn", prefix, args);
    },
    error(prefix, ...args) {
      base("error", prefix, args);
    },

    // Explicit-only trace (you call it when you want callsite)
    trace(prefix, ...args) {
      if (!enabled) return;
      console.log(prefix, ...args);
      console.groupCollapsed(`${prefix} (trace)`);
      console.trace();
      console.groupEnd();
    },
  };
}

export function applyUserFlagPreset() {
  // intentionally empty
}

// Session-local dedup, one email per key not per call. Falls back to full message.
const reportedErrorKeys = new Set();

export const handleError = async (errorMessage, user, dedupeKey) => {
  const key = dedupeKey || errorMessage;
  if (reportedErrorKeys.has(key)) {
    console.log("LogHelpers: suppressing duplicate error report:", key);
    return;
  }
  reportedErrorKeys.add(key);

  console.log("errorMessage", errorMessage);
  console.log("User", user);

  const safeUserEmail = user?.email ? String(user.email) : "unknown";
  const msg = `${errorMessage}<p>User: ${safeUserEmail}</p>`;

  try {
    const response = await fetch(LambdaURLs.HANDLE_ERROR, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: msg,
        recipient: "dan.carroll@hyperionlive.com",
      }),
    });

    if (!response.ok) {
      console.error("Error notifying Lambda:", response.statusText);
      return;
    }

    const responseData = await response.json();
    console.log("Error notification sent to Lambda:", responseData);
  } catch (err) {
    console.error("Error making request to Lambda:", err);
  }
};
